import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { successToast, errorToast } from "../../Utils/toast";
// import { STATUS_OPTIONS } from "../../Constant/leadConstent";
import { STATUS_OPTIONS_d } from "../../Constant/leadConstent";
import { closeModal } from "../../redux/features/modalSlice";
import { updateLeadStatus } from "../../redux/services/leadServices/Lead.Services";
import { getRemarkList } from "../../redux/services/RemarkServices/Remark.Services";

function AddRemark({ data }) {
  const dispatch = useDispatch();
  const role = localStorage.getItem("role");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    status: data?.currentStatus || "",
    remarks: "",
    followup_date: new Date().toISOString().split("T")[0],
    date: new Date().toISOString().split("T")[0],
    time: new Date().toTimeString().split(" ")[0],
    file: null,
  });
  const validateForm = () => {
    let newErrors = {};

    if (!formData.remarks.trim()) {
      newErrors.remarks = "Remark is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!validateForm()) return;
      // const payload = {
      //   id: data.id,
      //   status: formData.status,
      //   remarks: formData.remarks,
      //   followup_date: formData.followup_date,
      // };
      const payload = new FormData();

      payload.append("id", data.id);
      payload.append("status", formData.status);
      payload.append("remarks", formData.remarks);
      payload.append("followup_date", formData.followup_date);
      payload.append("date", formData.date);
      payload.append("time", formData.time);


      if (formData.file) {
        payload.append("file", formData.file);
      }

      const res = await data.onSubmit(payload);

      if (res?.success) {
        successToast(res.message);
        if (data?.refreshRemarks) {
          await data.refreshRemarks();
        }
        dispatch(closeModal());
      } else {
        errorToast(res.message);
      }

    } catch (err) {
      console.log(err);
      errorToast(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-3">

      {/* STATUS */}
      <div className="mb-3">
        <label>Status</label>
        <select
          name="status"
          className="form-select"
          value={formData.status}
          onChange={handleChange}
        >
          <option value="">Select Status</option>

          {/* {STATUS_OPTIONS.map((item) => (
            <option key={item.value} value={item.value}>
              {item.value}
            </option>
          ))} */}
          {STATUS_OPTIONS_d
            .filter(
              (item) =>
                role === "admin" ||
                !["New", "Assigned"].includes(item.value)
            )
            .map((item) => (
              <option key={item.value} value={item.value}>
                {item.value}
              </option>
            ))}
        </select>
      </div>

      {/* REMARK */}
      {/* <div className="mb-3">
        <label>Remark</label>
        <textarea
          name="remarks"
          className="form-control"
          rows="3"
          value={formData.remarks}
          onChange={handleChange}
      
        />
      </div> */}
      <div className="mb-3">
        <label>
          Remark <span className="text-danger">*</span>
        </label>

        <textarea
          name="remarks"
          className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
          rows="3"
          value={formData.remarks}
          onChange={(e) => {
            handleChange(e);

            if (errors.remarks) {
              setErrors((prev) => ({
                ...prev,
                remarks: "",
              }));
            }
          }}
        />

        {errors.remarks && (
          <div className="invalid-feedback">
            {errors.remarks}
          </div>
        )}
      </div>

      {/* DATE */}
      <div className="mb-3">
        <label>Followup Date</label>
        <input
          type="date"
          name="followup_date"
          className="form-control"
          value={formData.followup_date}
          onChange={handleChange}
        />
      </div>
      <div className="mb-3">
        <label>Upload File</label>
        <input
          type="file"
          name="file"
          className="form-control"
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              file: e.target.files[0],
            }))
          }
        />
      </div>

      {/* BUTTONS */}
      <div className="d-flex gap-2">
        <button
          className="btn btn-danger"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="add-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Remark"}
        </button>
      </div>

    </div>
  );
}

export default AddRemark;